import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { LabMaterial } from 'models/material';
import { useTranslation } from 'react-i18next';
import EditMaterialForm from './edit-material-form.component';

type EditMaterialDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    materialToEdit: LabMaterial;
    onEditMaterial: (material: LabMaterial) => void;
};
const EditMaterialDialog: FC<EditMaterialDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    materialToEdit,
    onEditMaterial,
}: EditMaterialDialogProps) => {
    const { t: translate } = useTranslation('lab-settings');
    return (
        <Dialog fullWidth maxWidth="md" open={dialogOpen}>
            <DialogTitle>{translate('lab-settings:EDIT_MATERIAL')}</DialogTitle>
            <EditMaterialForm
                onCloseDialog={onCloseDialog}
                materialToEdit={materialToEdit}
                onEditMaterial={onEditMaterial}
            />
        </Dialog>
    );
};

export default EditMaterialDialog;
